module.exports = __webpack_public_path__ + "img/logo-1.38bb1353.png";